import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-71c29d96"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "card-box"
};
const _hoisted_2 = {
  class: "online-card"
};
const _hoisted_3 = {
  key: 0,
  class: "online-link"
};

const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<img class=\"bg-img-path\" src=\"https://image.zhihuishu.com/zhs/b2cm/base1/202408/b499ab5345c749709d336c4f1a20e67a.png\" alt=\"\" data-v-71c29d96><a href=\"//spoc-ai-teaching-center.zhihuishu.com/l4/tchCalendar\" data-v-71c29d96><img class=\"new-path\" src=\"https://image.zhihuishu.com/zhs/b2cm/base1/202408/37960469bce14b83b755af2db85e276b.png\" alt=\"\" data-v-71c29d96></a><a href=\"//onlineweb.zhihuishu.com/onlineMuster/teacherIndex\" data-v-71c29d96><img class=\"old-path\" src=\"https://image.zhihuishu.com/zhs/b2cm/base1/202408/8aa821f8076d467d8453e9bc8ef866d8.png\" alt=\"\" data-v-71c29d96></a>", 3);

const _hoisted_7 = [_hoisted_4];
const _hoisted_8 = ["href"];

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://image.zhihuishu.com/zhs/b2cm/base1/202408/d62697080f7141c2b2ac2472f65a0994.png",
  alt: ""
}, null, -1));

const _hoisted_10 = [_hoisted_9];
const _hoisted_11 = {
  key: 0,
  class: "menu-list"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  class: "left"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "menu-title"
};

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-chakanquanbu arrow-icon"
}, null, -1));

const _hoisted_17 = {
  key: 1,
  class: "menu-card"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  class: "card-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TipDialog = _resolveComponent("TipDialog");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$props.zhsRole == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_7)) : (_openBlock(), _createElementBlock("a", {
    key: 1,
    href: $props.onlineLink,
    target: "_blank",
    class: "online-link"
  }, _hoisted_10, 8, _hoisted_8))]), $props.zhsRole == 3 || $props.zhsRole == 0 ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.menuList, item => {
    return _openBlock(), _createElementBlock("li", {
      class: "menu-item",
      key: item.name,
      onClick: $event => $options.handleLink(item.link)
    }, [_createElementVNode("div", _hoisted_13, [_createElementVNode("img", {
      src: item.img,
      alt: "",
      class: "menu-icon"
    }, null, 8, _hoisted_14), _createElementVNode("span", _hoisted_15, _toDisplayString(item.name), 1)]), _hoisted_16], 8, _hoisted_12);
  }), 128))])) : (_openBlock(), _createElementBlock("ul", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.menuList, item => {
    return _openBlock(), _createElementBlock("li", {
      class: "card-item",
      key: item.name,
      onClick: $event => $options.handleLink(item.link)
    }, [_createElementVNode("img", {
      src: item.img,
      class: "card-icon",
      alt: ""
    }, null, 8, _hoisted_19), _createElementVNode("span", _hoisted_20, _toDisplayString(item.name), 1)], 8, _hoisted_18);
  }), 128))]))]), _createVNode(_component_TipDialog, {
    show: $data.showDialog,
    "onUpdate:show": _cache[0] || (_cache[0] = $event => $data.showDialog = $event)
  }, null, 8, ["show"])], 64);
}